const todayDate = (new Date()).toDateString();
export default {
  data() {
    return {
      todayDate
    }
  },
  filters: {
    avatar(value) {
      return value.replace(' - ', ' ').split(' ')
        .map(name => name.substring(0, 1).toUpperCase())
        .splice(0, 2)
        .join('');
    },
    user_role(value) {
      if (value == 'staff') return 'Staff';
      if (value == 'user') return 'Client';
      if (value == 'department') return 'Department';
      return 'Client';
    }
  },
  computed: {
    onlineStaffIds() {
      return this.$store.state.auth.onlineIds.filter(id => typeof id == 'number');
    },
    onlineClientIds() {
      return this.$store.getters.onlineClientIds;
    },
  }
}
